import React from "react";
import AudiencePage from "@/components/AudiencePage";
import { AUDIENCES } from "@/data/content";

export default function PropertyManagerPage() {
  return <AudiencePage config={AUDIENCES["property-manager"]} />;
}
